import { render, staticRenderFns } from "./health.vue?vue&type=template&id=67d99079&scoped=true"
import script from "./health.vue?vue&type=script&lang=ts"
export * from "./health.vue?vue&type=script&lang=ts"
import style0 from "./health.vue?vue&type=style&index=0&id=67d99079&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d99079",
  null
  
)

export default component.exports